<template>
	<div class="special-box-product-search--modal">
		<ManagingSection>
			<ManagingBox title="상품명">
				<input v-model="productTitle" type="text" />
			</ManagingBox>
			<ManagingBox title="상품코드">
				<input v-model="productCode" type="text" />
			</ManagingBox>
			<ManagingBox title="브랜드">
				<search-brand @change="setBrand" />
			</ManagingBox>
		</ManagingSection>
		<div class="btn-wrap-main">
			<button @click="getSearch(0)" class="btn-main blue" type="button">
				검색
			</button>
		</div>
		<ManagingSection :isTable="true" :tableMaxHeight="300">
			<template slot="infoSection">
				<span class="section__info__left"
					>검색결과 : {{ contentTotal | currency }} 개</span
				>
				<div class="section__info__right">
					<select
						class="select section__info__items"
						aria-label="페이지 당 출력 갯수"
						v-model="limit"
						@change="onLimitChange"
					>
						<option :value="10">10개씩 보기</option>
						<option :value="20">20개씩 보기</option>
						<option :value="30">30개씩 보기</option>
						<option :value="50">50개씩 보기</option>
						<option :value="100">100개씩 보기</option>
					</select>
				</div>
			</template>
			<table class="table-main">
				<thead>
					<tr>
						<th>
							<input
								type="checkbox"
								ref="toggleAll"
								@change="toggleAll($event.target.checked)"
							/>
						</th>
						<th>상품코드</th>
						<th>상품명</th>
						<th>판매가</th>
						<th>소비자가</th>
						<th>할인가(할인기간)</th>
						<th>진열상태</th>
						<th>판매상태</th>
						<th>품절여부</th>
						<th>상품상태</th>
					</tr>
				</thead>
				<tbody v-if="searchResult.length === 0">
					<tr>
						<td colspan="10">검색결과가 없습니다.</td>
					</tr>
				</tbody>
				<tbody v-else-if="searchResult.length > 0">
					<tr :key="item.productCode" v-for="item in searchResult">
						<td>
							<input
								type="checkbox"
								ref="itemAddToggle"
								@change="itemAddToggle($event, item)"
							/>
						</td>
						<td>{{ item.productCode }}</td>
						<td>
							<table-item-product-box
								:src="item.filePath"
								:name="item.productTitle"
								@click.native="linkToEc(item.ecIdProduct)"
							/>
						</td>
						<td>{{ item.salePrice | currency }}</td>
						<td>{{ item.retailPrice | currency }}</td>
						<td>
							<template
								v-if="isValidDiscount(item.discountEndAt)"
							>
								{{ item.currentSalePrice | currency }}<br />
								({{
									discountTimeFormat(item.discountStartAt)
								}}
								~ {{ discountTimeFormat(item.discountEndAt) }})
							</template>
							<template v-else> - </template>
						</td>
						<td>{{ item.isDisplay ? '진열함' : '진열안함' }}</td>
						<td>{{ item.isSale ? '판매함' : '판매안함' }}</td>
						<td>{{ item.isSoldOut ? '품절' : '품절아님' }}</td>
						<td>{{ itemStatus(item.productAuditCd) }}</td>
					</tr>
				</tbody>
			</table>
		</ManagingSection>
		<pagination-box
			class="pagination-box"
			:totalItem="getTotal"
			:offset="getCursor"
			:limit="limit"
			:pageLengPerOne="pageGroupLimit"
			@to="paging"
		/>
		<div class="btn-wrap-main">
			<button @click="adding" class="btn-main blue" type="button">
				추가하기
			</button>
			<button @click="close" class="btn-main blue bordered" type="button">
				닫기
			</button>
		</div>
	</div>
</template>

<script>
	import ManagingSection from '@/components/layout/ManagingSection.vue';
	import ManagingBox from '@/components/layout/ManagingBox.vue';
	import SearchBrand from '@/components/SearchBrand.vue';
	import TableItemProductBox from '@/components/TableItemProductBox.vue';
	import PaginationBox from '@/components/PaginationBox';
	import SpecialBoxMixin from '@/components/modals/modules/_SpecialBoxMixin';
	import moment from 'moment';

	export default {
		name: 'SpecialBoxProductSearch',
		components: {
			ManagingSection,
			ManagingBox,
			SearchBrand,
			TableItemProductBox,
			PaginationBox,
		},
		mixins: [SpecialBoxMixin],
		data() {
			return {
				productTitle: null,
				productCode: null,
			};
		},
		computed: {
			getTotal() {
				return this.contentTotal;
			},
			getCursor() {
				return this.offset;
			},
		},
		mounted() {
			this.getSearch();
		},
		methods: {
			discountTimeFormat(timestamp) {
				return moment(new Date(timestamp * 1000)).format('MM-DD HH:mm');
			},
			isValidDiscount(timestamp) {
				return (
					!!timestamp &&
					Number(timestamp) > Number(moment().format('X'))
				);
			},
			linkToEc(id) {
				window.open(
					`${this.$store.state.env.adminEcDomain}/admin/product/popup/productModify?productId=${id}`
				);
			},
			getSearch(offset) {
				this.initCheckedItem();

				if (typeof offset === 'number') {
					this.offset = offset;
				}

				const params = {
					productCode: this.valueOrNull(this.productCode),
					productTitle: this.valueOrNull(this.productTitle),
					idBrand: this.idBrand,
					limit: this.limit,
					offset: this.offset,
				};

				this.$axiosAdmin2
					.post('/api/display/home/store/products/search', params)
					.then(({ data }) => {
						this.searchResult = data.data;
						this.contentTotal = data.contentTotal;
					})
					.catch(({ response }) => {
						console.error(response);
					});
			},
			adding() {
				this.$store.commit('SPBoxProducts/add', this.itemChecked);

				if (this.$store.state.SPBoxProducts.isSuccess) {
					this.$store.commit('modal/toggleModal', false);
				}
			},
			itemStatus(value) {
				const textList = [
					'임시저장',
					'심사대기',
					'신규 심사반려',
					'신규 심사승인',
					'수정 심사대기',
					'수정 심사반려',
					'수정 심사승인',
					'임시저장(어드민)',
				];

				return textList[parseInt(value) - 1];
			},
		},
	};
</script>

<style lang="scss" scoped>
	.pagination-box {
		padding-top: 1em;
	}
</style>
